<button
  class="root -size-{{ getSize() }} -type-{{ type() }}"
  [disabled]="disabled()"
  [class.-disabled]="disabled()"
  [class.-round]="round()"
  [class.-stretch-content]="stretchContent()"
  [class.-flush]="flush()"
  [attr.aria-controls]="ariaControls() ?? null"
  [attr.aria-expanded]="ariaExpanded() ?? null"
  [attr.aria-current]="ariaCurrent() ?? null"
  [attr.aria-label]="ariaLabel() ?? null"
  [class.-mobile]="isMobile"
  [class.-spinner]="spinner()"
  [class.-has-alone-icon]="isAloneIcon()"
  [class.-has-left-icon]="leftIcon.childNodes.length"
  [class.-has-right-icon]="rightIcon.childNodes.length"
  (click)="checkPropagation($event)"
  [attr.type]="nativeType()"
  #root
>
  @if (spinner()) {
    <ds-spinner class="spinner" [size]="getSpinnerSize()" [color]="getSpinnerColor()"></ds-spinner>
  }

  <div class="icon-alone">
    <ng-content select="[icon]"></ng-content>
  </div>

  <div class="icon-left" #leftIcon>
    <ng-content select="[iconLeft]"></ng-content>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>

  <div class="icon-right" #rightIcon>
    <ng-content select="[iconRight]"></ng-content>
  </div>
</button>
